export default __webpack_public_path__ + "static/media/tooltip.545a3af6.svg";